export default __webpack_public_path__ + "static/daniela-b8e52fc1b271977bbc1606454b233fe2.jpg";